// extracted by mini-css-extract-plugin
module.exports = {"header":"PageWithHeader_header__35aqc","container":"PageWithHeader_container__2Daew"};